import { FC, useMemo } from 'react';

import { Box } from '@mui/material';

import GeoMapView from 'src/components/GeoMapView/GeoMapView';
import ReusableGrid from 'src/components/ReusableGrid';
import SubNavigation, { Step } from 'src/components/SubNavigation/SubNavigation';
import { DEFAULT_BORDER } from 'src/constants';
import { Principal } from 'src/types/AddMerchant/merchantInfo';
import buildContact from 'src/utils/buildContact';

interface ContactMapSectionProps {
    principals: Principal[];
    height: number | string;
    coordinates?: {
        latitude: number;
        longitude: number;
        name: string;
    };
}

const npiOfficeCoordinates = {
    latitude: 53.29288290775429,
    longitude: -6.426774858980775,
    name: 'NPI Office',
};

const ContactMapSection: FC<ContactMapSectionProps> = ({ principals, height, coordinates }) => {
    const contactInformation = useMemo(() => {
        return buildContact(principals);
    }, [principals]);
    const steps: Step[] = contactInformation.map((_c, i) => {
        return {
            label: `Principal ${i + 1}`,
            step: `principal${i + 1}`,
        };
    });

    return (
        <Box flex="0 0 73%" height={height}>
            <ReusableGrid title="Contact Information" xs={12} enableContainer>
                <Box display="flex" gap={2} height="100%" px={3} pb={3}>
                    {/* left – contact list */}
                    <Box flex="0 0 50%" sx={{ '& .MuiMenuList-root': { display: 'none' } }}>
                        <SubNavigation steps={steps} contactInformation={contactInformation} />
                    </Box>

                    {/* right – map placeholder */}
                    <Box
                        flex="1"
                        sx={{
                            ...DEFAULT_BORDER,
                            bgcolor: '#F5F5F5',
                            borderRadius: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'auto',
                        }}
                    >
                        {coordinates && (
                            <GeoMapView
                                longitude={coordinates.longitude}
                                latitude={coordinates.latitude}
                                address={coordinates.name}
                            />
                        )}

                        {!coordinates && (
                            <GeoMapView
                                longitude={npiOfficeCoordinates.longitude}
                                latitude={npiOfficeCoordinates.latitude}
                                address={npiOfficeCoordinates.name}
                            />
                        )}
                    </Box>
                </Box>
            </ReusableGrid>
        </Box>
    );
};

export default ContactMapSection;
